
import { useDataQuery } from '@dhis2/app-runtime'


// Query for goal-objective linkage events
const GOAL_LINKAGE_QUERY = {
  goalLinkage: {
    resource: 'events',
    params: () => ({
      program: 'NkReudUAW4F',          // Goals program
      programStage: 'IEsUtu84bQU',     // Linkage stage
      fields: 'event,dataValues[dataElement,value]',
      pageSize: 1000,
      totalPages: true
    })
  }
};

export const useGoalLinkageData = (orgUnitId) => {
  return useDataQuery(GOAL_LINKAGE_QUERY, {
    variables: { orgUnit: orgUnitId }
  });
};

// Combined query to get all performance data in one request
const PERFORMANCE_QUERY = {
  objectives: {
    resource: 'events',
    params: ({ orgUnit }) => ({
      orgUnit: orgUnit,
      ouMode: 'ACCESSIBLE',
      program: 'yiT00XKrrHP',
      programStage: 'VIBtpvkpHFR',
      fields: 'event,orgUnit,orgUnitName,eventDate,dueDate,storedBy,createdByUserInfo,lastUpdatedByUserInfo,dataValues[dataElement,value]',
      pageSize: 1000
    })
  },
  tasks: {
    resource: 'events',
    params: ({ orgUnit }) => ({
      orgUnit: orgUnit,
      ouMode: 'ACCESSIBLE',
      program: 'yiT00XKrrHP',
      programStage: 'Nv9nYNcBTdM',
      fields: 'event,orgUnit,orgUnitName,eventDate,dueDate,dataValues[dataElement,value]',
      pageSize: 1000
    })
  },
  kras: {
    resource: 'events',
    params: ({ orgUnit }) => ({
      orgUnit: orgUnit,
      ouMode: 'ACCESSIBLE',
      program: 'yiT00XKrrHP',
      programStage: 'BJb3qTgbcTF',
      fields: 'event,orgUnit,orgUnitName,eventDate,dueDate,dataValues[dataElement,value]',
      pageSize: 1000
    })
  },
  kpis: {
    resource: 'events',
    params: ({ orgUnit }) => ({
      orgUnit: orgUnit,
      ouMode: 'ACCESSIBLE',
      program: 'yiT00XKrrHP',
      programStage: 'ivyCLjNLFrd',
      fields: 'event,orgUnit,orgUnitName,eventDate,dueDate,dataValues[dataElement,value]',
      pageSize: 1000
    })
  }
}

// Query to get organizational goals
const GOALS_QUERY = {
  goals: {
    resource: 'events',
    params: () => ({
      program: 'NkReudUAW4F',
      programStage: 'VomTWbJot7U',
      fields: 'event,orgUnit,orgUnitName,eventDate,dueDate,dataValues[dataElement,value]',
      pageSize: 1000,
      totalPages: true
    })
  }
}


// Query to get users for staff assignment
const USERS_QUERY = {
  users: {
    resource: 'users',
    params: {
      fields: 'id,displayName,firstName,surname,username,organisationUnits[id,name],userCredentials[userRoles[id,name]]',
      pageSize: 1000
    }
  }
}

export const usePerformanceData = (orgUnitId) => {
  return useDataQuery(PERFORMANCE_QUERY, {
    variables: { orgUnit: orgUnitId }
  });
};

export const useGoalsData = (orgUnitId) => {
  return useDataQuery(GOALS_QUERY, {
    variables: { orgUnit: orgUnitId }
  });
};

export const useUsersData = () => {
  return useDataQuery(USERS_QUERY)
}

// Individual queries for backward compatibility
export const useObjectivesData = (orgUnitId) => {
  return useDataQuery({
    objectives: PERFORMANCE_QUERY.objectives
  }, {
    variables: {
      orgUnit: orgUnitId
    }
  })
}

export const useTasksData = (orgUnitId) => {
  return useDataQuery({
    tasks: PERFORMANCE_QUERY.tasks
  }, {
    variables: {
      orgUnit: orgUnitId
    }
  })
}

export const useKrasData = (orgUnitId) => {
  return useDataQuery({
    kras: PERFORMANCE_QUERY.kras
  }, {
    variables: {
      orgUnit: orgUnitId
    }
  })
}
